// @flow

import styled, { type ReactComponentStyled } from 'styled-components';

import type { Theme, AppState } from '../common/typings';
import { ANIMATION_DURATION_CSS } from '../constants';

type Props = {
  theme: Theme,
  appState: AppState
};

const MainScreen: ReactComponentStyled<Props> = styled.div`
  display: flex;
  flex-wrap: nowrap;
  background: ${props => props.theme.appScreenState[props.appState] || props.theme.brand};
  transition: background-color ${ANIMATION_DURATION_CSS} ease-in-out;
  padding: 0;
  overflow: hidden;
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
`;

export default MainScreen;
